import type { ModalOverlayProps } from 'react-aria-components'
import { ModalOverlay, Modal as RACModal, composeRenderProps } from 'react-aria-components'
import tv from '~/lib/tv'

const overlayStyles = tv({
  base: 'fixed top-0 left-0 w-full h-full isolate z-20 bg-black/[15%] flex items-center justify-center p-4 text-center backdrop-grayscale-0',
  variants: {
    isEntering: {
      true: 'animate-in fade-in duration-200 ease-out',
    },
    isExiting: {
      true: 'animate-out fade-out duration-200 ease-in',
    },
  },
})

const modalStyles = tv({
  base: 'w-full max-w-md max-h-full rounded-lg bg-white forced-colors:bg-[Canvas] text-left align-middle shadow-2xl bg-clip-padding',
  variants: {
    isEntering: {
      true: 'animate-in zoom-in-105 ease-out duration-200',
    },
    isExiting: {
      true: 'animate-out zoom-out-95 ease-in duration-200',
    },
  },
})

export function Modal(
  props: ModalOverlayProps & { modalOverlayClassName?: React.HTMLAttributes<HTMLElement>['className'] },
) {
  return (
    <ModalOverlay
      {...props}
      className={composeRenderProps(props.modalOverlayClassName, (className, renderProps) =>
        overlayStyles({
          ...renderProps,
          className,
        }),
      )}
    >
      <RACModal
        {...props}
        className={composeRenderProps(props.className, (className, renderProps) =>
          modalStyles({
            ...renderProps,
            className,
          }),
        )}
      />
    </ModalOverlay>
  )
}
